import router from './routes';

function App(): JSX.Element {
  return router;
}

export default App;
